import React from 'react'

const SeparatorBullet = (): JSX.Element => <span>&bull;</span>

export default SeparatorBullet
